/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountLoyaltyTileViewProps } from '@msdyn365-commerce-modules/account-management';
import { IAccountLoyaltyTileProps } from '../../../themes/venchi/definition-extensions/account-loyalty-tile.ext.props.autogenerated';
import { TEMPORARY_ACCOUNT_NUMBER_LENGTH } from '../utils/constants';

const AccountLoyaltyTileView: React.FC<IAccountLoyaltyTileViewProps & IAccountLoyaltyTileProps<{}>> = props => {
    const { AccountLoyaltyTile, heading, description, links } = props;

    // The user does NOT have a customer number yet, they still have a tmp_guid
    let tmp_account = false;
    if (props.context.request.user.customerAccountNumber?.length === TEMPORARY_ACCOUNT_NUMBER_LENGTH) {
        tmp_account = true;
    }

    let description__no_decimals;

    // @ts-ignore
    if (description && description.props) {
        // @ts-ignore
        description__no_decimals = description.props.description.replace('.00', '');
    }

    return (
        <Module {...AccountLoyaltyTile}>
            {heading}
            <p className='ms-account-loyalty-tile__description'>
                {tmp_account && props.config.usingNewLoyalty && props.config.cardBeingGeneratedText
                    ? props.config.cardBeingGeneratedText
                    : description__no_decimals}
            </p>
            {links}
        </Module>
    );
};

export default AccountLoyaltyTileView;
